module.exports = __webpack_public_path__ + "static/newsletter-bg-eb8e31aa0ee1bd350a800ed85ef9a546.png";